export const blogStyle = {
    computer: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "70%",
            marginBottom: "2%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        entry: {
            color: "white",
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            margin: "0 auto",
            width: "70%",
            padding: "1%",
            overflowY: "auto",
            maxHeight: "715px"
        }
    },
    tablet: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "70%",
            marginBottom: "2%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        entry: {
            color: "white",
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            margin: "0 auto",
            width: "70%",
            padding: "1%",
            overflowY: "auto",
            maxHeight: "715px"
        }
    },
    mobile: {
        page: {
            marginTop: "3%"
        },
        headerContainer: {
            margin: "0 auto",
            width: "70%",
            marginBottom: "2%"
        },
        header: {
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        entry: {
            color: "white",
            fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
        },
        container: {
            backgroundColor: "rgb(180, 74, 70)",
            margin: "0 auto",
            width: "70%",
            padding: "1%",
            overflowY: "auto",
            maxHeight: "715px"
        }
    }
};